module.exports = __webpack_public_path__ + "static/media/charizard_0.bf7cd523.png";